import { render, staticRenderFns } from "./RecentPodcast.vue?vue&type=template&id=9d71ab84"
import script from "./RecentPodcast.vue?vue&type=script&lang=js"
export * from "./RecentPodcast.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports